<div class="score-container">
  <div class="score-wrapper">
    <label class="score-label" for="nota">Nota:</label>
    <input
      class="score-input"
      type="number"
      min="0"
      max="10"
      name="nota"
      cdkFocusInitial
      [(ngModel)]="nota"
      [disabled]="disabled"
      (keydown.enter)="validateNota()" />
    <button mat-raised-button color="primary" (click)="validateNota()" [disabled]="disabled">Confirmar</button>
    <span class="score-hint">(0 a 10)</span>
    <span class="score-hint-bold">Peso {{ peso }}</span>
    <span class="score-hint-bold">{{ getDescricaoTipoProva() }}</span>
  </div>
</div>
